/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramConnectionsUserControllerMarkIncomingAsReadMutationResponse,
  TelegramConnectionsUserControllerMarkIncomingAsRead401,
} from '../../types/TelegramConnectionsUserControllerMarkIncomingAsRead.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramConnectionsUserMarkIncomingAsRead } from '../../methods/telegramConnectionsUserMarkIncomingAsRead.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramConnectionsUserMarkIncomingAsReadMutationKey = () =>
  [{ url: '/api/user/telegram/connections/incoming/read' }] as const;

export type TelegramConnectionsUserMarkIncomingAsReadMutationKey = ReturnType<
  typeof telegramConnectionsUserMarkIncomingAsReadMutationKey
>;

/**
 * @summary Mark all incoming connections as read
 * {@link /api/user/telegram/connections/incoming/read}
 */
export function useTelegramConnectionsUserMarkIncomingAsRead<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramConnectionsUserControllerMarkIncomingAsReadMutationResponse,
      ResponseErrorConfig<TelegramConnectionsUserControllerMarkIncomingAsRead401>,
      void,
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramConnectionsUserMarkIncomingAsReadMutationKey();

  return useMutation<
    TelegramConnectionsUserControllerMarkIncomingAsReadMutationResponse,
    ResponseErrorConfig<TelegramConnectionsUserControllerMarkIncomingAsRead401>,
    void,
    TContext
  >(
    {
      mutationFn: async () => {
        return telegramConnectionsUserMarkIncomingAsRead(config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
